// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_EAR","cls2":"PaperBrowserPreviewList-cls2_U6v PaperBrowserPreviewList-cls1_EAR"};